import React, { useEffect, useState } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
// import { getServices } from "../../apiServices/apiServices";
// import toast from "react-hot-toast";
import LoadingGif from "../../assets/loading_anim.gif";
// import ManifoldReportTable from "../../components/common/ManifoldReportTable";
import { MdOutlineMoreVert } from "react-icons/md";
import EmptyingReport from "../reports/EmptyingReport";
import { getServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";

function HeadControllerDetails() {
  const [controllerDetails, setControllerDetails] = useState({});
  // const [manifoldReportData, setManifoldReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // const access_token = localStorage.getItem("gassol-head-branch-token");

  useEffect(() => {
    if (!localStorage.getItem("gassol-head-branch-token")) {
      navigate("/sign_in");
    }

    window.scrollTo(0, 0);

    // fetchManifoldReportData();
    fetchControllerDetails();
  }, [navigate]);

  const fetchControllerDetails = async () => {
    setLoading(true);

    try {
      const res = await getServices(
        `/api/hardware/data?hardware_id=${location.state?.hardware_id ?? ""}`
      );
      setLoading(false);

      if (res.responseCode === 200) {
        setControllerDetails(res.responseData[0]);
      } else {
        setControllerDetails({});
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  // const fetchManifoldReportData = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await getServices(
  //       `/api/device/manifold/runtime?branch_id=${location.state.sub_branch_id}`,
  //       access_token
  //     );
  //     setLoading(false);
  //     if (res.responseCode === 200) {
  //       setManifoldReport(res.responseData?.data);
  //       fetchControllerDetails(res.responseData?.data?.[0]?.id);
  //     } else {
  //       setManifoldReport([]);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     toast.error(error);
  //   }
  // };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        {!loading ? (
          <>
            <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
              <div className="flex gap-3 sm:gap-6">
                <Link
                  to={-1}
                  className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
                >
                  <IoChevronBackOutline />
                  <p>Controller Details</p>
                </Link>
              </div>
            </div>
            <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 sm:gap-2 mt-4 md:mt-8 mb-4">
              <div>
                <p className="text-[#BDBDBD] text-sm">Hardware Name</p>
                <p className="text-black font-bold text-4xl">Switch Right</p>
                {/* <p className="text-black font-semibold text-2xl">
                  Branch: {location.state?.subbranchName}
                </p> */}
              </div>

              <div className="flex gap-3 ml-auto">
                {/* <Button
                  onClick={() => {
                    window.open(
                      `/controller_details/burner_report/${location.state.sub_branch_id}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Burner Report
                </Button>
                <Button
                  onClick={() => {
                    window.open(
                      `/controller_details/cylinder_weight_report/${location.state.sub_branch_id}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Cylinder Report
                </Button> */}
                {controllerDetails?.reportInfo?.[0]?.gld_report !== 0 && (
                  <Button
                    onClick={() => {
                      navigate("/head_office/controller_details/gld_logs", {
                        state: { controllerDetails: controllerDetails },
                      });
                    }}
                    className="font-poppins font-medium tracking-wider bg-[#03438D]"
                  >
                    GLD Logs
                  </Button>
                )}

                <Menu placement="left-start">
                  <MenuHandler title="Click to open reports">
                    <Button className="p-2 rounded-full bg-[#03438D] outline-none">
                      <MdOutlineMoreVert className="text-2xl" />
                    </Button>
                  </MenuHandler>
                  <MenuList>
                    {controllerDetails?.reportInfo?.[0]?.br_report === 1 && (
                      <MenuItem
                        onClick={() => {
                          window.open(
                            `/controller_details/burner_report/${location.state.sub_branch_id}`,
                            "_blank"
                          );
                        }}
                        className="font-poppins"
                      >
                        Burner Report
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/cylinder_weight_report/${location.state.sub_branch_id}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Cylinder Report
                    </MenuItem>
                    {/* <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/emptying_report/${location.state.sub_branch_id}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Emptying Report
                    </MenuItem> */}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offline_report/${location.state.sub_branch_id}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Offline Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offtime_report/${location.state.sub_branch_id}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Off-time Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/graph_view/${location.state.sub_branch_id}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Graph View
                    </MenuItem>
                  </MenuList>
                </Menu>
              </div>
            </div>

            {/* manifold report */}
            {location.state ? (
              <>
                {/* <ManifoldReportTable
                  manifoldReportData={manifoldReportData}
                  controllerDetails={controllerDetails}
                /> */}
                <EmptyingReport branch_id={location.state.sub_branch_id} />
              </>
            ) : (
              <div className="text-center h-[50vh] flex flex-col justify-center items-center text-black">
                <p className="font-semibold text-xl sm:text-3xl">
                  Oops! No Data Found...
                </p>
                <p className="text-sm mt-2 ">
                  Looks like we couldn't find any branch that match your search
                  right now.
                </p>
              </div>
            )}
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[90vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default HeadControllerDetails;
